import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import mediaActions from '../../redux/component_select_media/actions'

// subcomponent
import HeadBar from './headbar'
import ListMedias from './list_medias'
import Paginate from './paginate'
import ModalMediaInfo from './modal_media_info'
import ModalConfirmDelete from './modal_confirm_delete'
import { Button } from 'antd'

// props: : khi select xong hoac huy thi se tra ve call back 
// onSuccess(selectList): khi nguoi dung lua chon
// onCancel(): khi nguoi dung khong chon
// initMedia: khoi tao select
class MediaManagementScreen extends Component {

    componentDidMount() {
        if (Array.isArray(this.props.initMedia)) {
            this.props.updateSelectedMedias(this.props.initMedia)
            this.props.loadListMedias({})
        }
    }

    componentWillReceiveProps = nextProps => {
        if (Array.isArray(nextProps.initMedia) && nextProps.initMedia !== this.props.initMedia) {
            this.props.updateSelectedMedias(nextProps.initMedia)
            this.props.loadListMedias({})
        }
    }

    _onClickOk = () => {
        this.props.onSuccess(this.props.selectedMedia)
        this.props.updateTextSearch("")
        this.props.searchMedia()
        this.props.updateSelectedMedias([])
    }

    _onCancel = () => {
        this.props.onCancel()
    }

    render() {
        const { height, selectLength } = this.props

        return (
            <div className="MediaScreen">
                <div style={{ minHeight: height - 200 }}>
                    <HeadBar />
                    <div style={{ marginTop: 10 }}>có {selectLength} tài liệu đã được chọn</div>
                    <ListMedias />

                    <div className="ButtonMediaInTask">
                        <Button
                            style={{ marginRight: 15 }}
                            type="primary"
                            onClick={this._onClickOk}
                        >
                            Chọn tài liệu
                        </Button>

                        <Button type="danger" onClick={this._onCancel}>
                            Huỷ
                        </Button>
                    </div>

                    <Paginate />
                    <ModalMediaInfo />
                    <ModalConfirmDelete />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.app,
        selectLength: state.component_select_media.selectedMedia.length,
        selectedMedia: state.component_select_media.selectedMedia
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListMedias: params => {
            dispatch(mediaActions.action.loadListMedias(params))
        },
        updateSelectedMedias: medias => {
            dispatch(mediaActions.action.updateSelectedMedias(medias))
        },
        updateTextSearch: textSearch => {
            dispatch(mediaActions.action.updateTextSearch(textSearch))
        },
        searchMedia: () => {
            dispatch(mediaActions.action.searchMedia())
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MediaManagementScreen)
